import React from 'react';
import { professionalWork } from '../../data/portfolio';

const ProfessionalWork = () => (
  <section className="section work-section" id="professional-work" aria-labelledby="work-title">
    <div className="shell">
      <div className="section-heading section-heading-row"><div><span className="section-number">03 / PROFESSIONAL WORK</span><h2 id="work-title">Systems built at NxtGen.</h2></div><p>Selected company work. Descriptions focus on the engineering approach and omit private implementation details.</p></div>
      <div className="work-grid">
        {professionalWork.map((project) => (
          <article className="work-card" key={project.title}>
            <div className="card-topline"><span>{project.number} / COMPANY PROJECT</span></div>
            <p className="card-category">{project.category}</p>
            <h3>{project.title}</h3>
            <div className="work-card-story">
              <p><span>THE PROBLEM</span>{project.problem}</p>
              <p><span>THE APPROACH</span>{project.summary}</p>
            </div>
            <div className="workflow" aria-label="High-level workflow">
              {project.workflow.map((step, index) => <React.Fragment key={step}>{index > 0 && <span className="workflow-arrow" aria-hidden="true">→</span>}<span>{step}</span></React.Fragment>)}
            </div>
            <p className="card-contribution"><strong>My contribution</strong>{project.contribution}</p>
            <div className="tag-list">{project.stack.map((tech) => <span className="tag" key={tech}>{tech}</span>)}</div>
            <details className="technical-details"><summary>Technical overview <span aria-hidden="true">+</span></summary><ul>{project.details.map((detail) => <li key={detail}>{detail}</li>)}</ul></details>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default ProfessionalWork;
